import { Component, Input, AfterContentInit, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

import { AppUser } from '../../../@core/models/app.user';
import { GeneralService } from '../../../@core/data/general.service';
import { LayoutService } from '../../../@core/data/layout.service';
import { generalSettings } from '../../../../main/settings';

@Component({
  selector: 'edm-email',
  templateUrl: './dialog.email.component.html',
  styleUrls: ['./dialog.email.component.scss'],
  host: {'[class]': '"transparent-modal"'},
  standalone: false
})

export class EmailDialogComponent implements OnInit, AfterContentInit, OnDestroy {

  mailSent: boolean = false;
  clearMailSent: number;

  @Input() model: AppUser;
  pathBaseTranslate: string = 'timeline.lessons.dialog-email.';

  constructor(
    private activeModal: NgbActiveModal,
    private generalService: GeneralService,
    private layoutService: LayoutService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.resend(false);
  }

  ngAfterContentInit(): void {
    if (this.model === null || this.model === undefined) {
      this.connectionError();
    }
  }

  ngOnDestroy(): void {
    this.mailSent = false;
    clearTimeout(this.clearMailSent);
  }

  private connectionError(): void {
    this.router.navigate(['produtos']);
  }

  exists(model: any): boolean {
    const defined: boolean = model !== null && model !== undefined;
    let notEmpty: boolean = true;
    if (typeof (model) == 'string') notEmpty = model != '';
    return defined && notEmpty;
  }

  resend(info: boolean = true): void {
    this.generalService.resend()
    .subscribe(
      (): void => {
        this.mailSent = info;
        this.clearMailSent = window.setTimeout((): void => {
          this.mailSent = false;
        }, 15000);
      },
      (): void => { }
    );
  }

  getTranslate(key: string): string {
    return this.generalService.getTranslate(`${this.pathBaseTranslate}${key}`);
  }

  buttonCustomLayoutCss(): string {
    return this.layoutService.buttonCustomLayoutCss();
  }

  iconCustomLayoutClass(): string {
    return generalSettings.timelineIconsLayout + '-icon';
  }

  iconTypeLayoutClass(): string {
    return generalSettings.iconsType + '-icons-type';
  }

  closeModal(submit: boolean = false): void {
    submit ? this.activeModal.close() : this.activeModal.dismiss();
  }
}
